// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Accordion primitive ─────────────────────────────────────── */
.accordion {
  border: 1px solid var(--border);
  border-radius: var(--r-data);
  overflow: hidden;
  background: var(--bg-alt);
}

.accordion-row {
  border-bottom: 1px solid var(--border-soft);
}
.accordion-row:last-child {
  border-bottom: 0;
}

.accordion-head {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
  color: var(--text);
  font-family: inherit;
  font-size: var(--fs-ui);
  transition: background 100ms ease;
}
.accordion-head:hover {
  background: var(--bg);
}

.accordion__chevron {
  color: var(--text-muted);
  font-size: var(--fs-note);
  line-height: 1;
  transition: transform 150ms ease;
  flex-shrink: 0;
  display: inline-block;
}
.accordion-row--open .accordion__chevron {
  transform: rotate(90deg);
}

.accordion__info {
  flex: 1;
  min-width: 0;
}
.accordion__name {
  font-size: var(--fs-ui);
  color: var(--text);
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion__meta {
  font-size: var(--fs-xs);
  color: var(--text-muted);
}

.accordion__count {
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  flex-shrink: 0;
}
.accordion__subtotal {
  font-family: var(--mono);
  font-size: var(--fs-ui);
  color: var(--text);
  flex-shrink: 0;
  min-width: 80px;
  text-align: right;
}

/* body */
.accordion__body {
  display: none;
  background: var(--bg);
  border-top: 1px solid var(--border-soft);
  padding: 0 14px;
}
.accordion-row--open .accordion__body {
  display: block;
}

.accordion__item {
  display: flex;
  align-items: baseline;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid var(--border-soft);
  font-size: var(--fs-2xs);
}
.accordion__item:last-child {
  border-bottom: 0;
}
.accordion__item-ref {
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  flex-shrink: 0;
}
.accordion__item-label {
  flex: 1;
  color: var(--text-secondary);
}
.accordion__item-value {
  font-family: var(--mono);
  font-size: var(--fs-2xs);
  color: var(--text);
}

/* job-status badge (result modal) */
.accordion__status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-family: var(--mono);
  font-size: var(--fs-sm);
  padding: 2px 7px;
  border-radius: var(--radius-full);
  flex-shrink: 0;
}
.accordion__status--ok {
  background: var(--ok-bg);
  color: var(--ok);
}
.accordion__status--danger {
  background: var(--err-bg);
  color: var(--danger);
}
.accordion__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: currentColor;
  display: inline-block;
}
`, "",{"version":3,"sources":["webpack://./src/ui/Accordion/Accordion.css"],"names":[],"mappings":"AAAA,mEAAmE;AACnE;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,iCAAiC;AACnC;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,cAAc;EACd,gCAAgC;EAChC,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,qBAAqB;EACrB,wCAAwC;EACxC,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,cAAc;EACd,2CAA2C;EAC3C,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,OAAO;EACP,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,wBAAwB;EACxB,qBAAqB;AACvB","sourcesContent":["/* ── Accordion primitive ─────────────────────────────────────── */\n.accordion {\n  border: 1px solid var(--border);\n  border-radius: var(--r-data);\n  overflow: hidden;\n  background: var(--bg-alt);\n}\n\n.accordion-row {\n  border-bottom: 1px solid var(--border-soft);\n}\n.accordion-row:last-child {\n  border-bottom: 0;\n}\n\n.accordion-head {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  color: var(--text);\n  font-family: inherit;\n  font-size: var(--fs-ui);\n  transition: background 100ms ease;\n}\n.accordion-head:hover {\n  background: var(--bg);\n}\n\n.accordion__chevron {\n  color: var(--text-muted);\n  font-size: var(--fs-note);\n  line-height: 1;\n  transition: transform 150ms ease;\n  flex-shrink: 0;\n  display: inline-block;\n}\n.accordion-row--open .accordion__chevron {\n  transform: rotate(90deg);\n}\n\n.accordion__info {\n  flex: 1;\n  min-width: 0;\n}\n.accordion__name {\n  font-size: var(--fs-ui);\n  color: var(--text);\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.accordion__meta {\n  font-size: var(--fs-xs);\n  color: var(--text-muted);\n}\n\n.accordion__count {\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  flex-shrink: 0;\n}\n.accordion__subtotal {\n  font-family: var(--mono);\n  font-size: var(--fs-ui);\n  color: var(--text);\n  flex-shrink: 0;\n  min-width: 80px;\n  text-align: right;\n}\n\n/* body */\n.accordion__body {\n  display: none;\n  background: var(--bg);\n  border-top: 1px solid var(--border-soft);\n  padding: 0 14px;\n}\n.accordion-row--open .accordion__body {\n  display: block;\n}\n\n.accordion__item {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--border-soft);\n  font-size: var(--fs-2xs);\n}\n.accordion__item:last-child {\n  border-bottom: 0;\n}\n.accordion__item-ref {\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  flex-shrink: 0;\n}\n.accordion__item-label {\n  flex: 1;\n  color: var(--text-secondary);\n}\n.accordion__item-value {\n  font-family: var(--mono);\n  font-size: var(--fs-2xs);\n  color: var(--text);\n}\n\n/* job-status badge (result modal) */\n.accordion__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  padding: 2px 7px;\n  border-radius: var(--radius-full);\n  flex-shrink: 0;\n}\n.accordion__status--ok {\n  background: var(--ok-bg);\n  color: var(--ok);\n}\n.accordion__status--danger {\n  background: var(--err-bg);\n  color: var(--danger);\n}\n.accordion__status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: currentColor;\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
